import {getPractice} from "utils/practiceStorage";

/*
 *
 * TimeSpanPlannerPage constants
 *
 */

export const DEFAULT_ACTION = "app/TimeSpanPlannerPage/DEFAULT_ACTION";

/**
 * Get timeslots
 */
export const GET_TIMESLOTS = "app/TimeSpanPlannerPage/GET_TIMESLOTS";
export const CLEAR_TIMESLOTS = "app/TimeSpanPlannerPage/CLEAR_TIMESLOTS";

export const GET_TIMESLOTS_FAILED =
  "app/TimeSpanPlannerPage/GET_TIMESLOTS_FAILED";
export const GET_TIMESLOTS_SUCCESS =
  "app/TimeSpanPlannerPage/GET_TIMESLOTS_SUCCESS";

export const GET_TIMESLOT_DRIVERS = "app/TimeSpanPlannerPage/GET_TIMESLOT_DRIVERS";
export const GET_TIMESLOT_DRIVERS_FAILED = "app/TimeSpanPlannerPage/GET_TIMESLOT_DRIVERS_FAILED";
export const GET_TIMESLOT_DRIVERS_SUCCESS = "app/TimeSpanPlannerPage/GET_TIMESLOT_DRIVERS_SUCCESS";

export const GET_AVAILABILITY_SCANNERS = "app/TimeSpanPlannerPage/GET_AVAILABILITY_SCANNERS";
export const GET_AVAILABILITY_SCANNERS_FAILED = "app/TimeSpanPlannerPage/GET_AVAILABILITY_SCANNERS_FAILED";
export const GET_AVAILABILITY_SCANNERS_SUCCESS = "app/TimeSpanPlannerPage/GET_AVAILABILITY_SCANNERS_SUCCESS";

/**
 * Get activity result
 */
export const GET_RESULT = "app/TimeSpanPlannerPage/GET_RESULT";
export const GET_RESULT_FAILED = "app/TimeSpanPlannerPage/GET_RESULT_FAILED";
export const GET_RESULT_SUCCESS = "app/TimeSpanPlannerPage/GET_RESULT_SUCCESS";

export const CHECK_AVAILABILITY = "app/TimeSPanPlannerPage/CHECK_AVAILABILITY";
export const CHECK_AVAILABILITY_FAILED =
  "app/TimeSPanPlannerPage/CHECK_AVAILABILITY_FAILED";
export const CHECK_AVAILABILITY_SUCCESS =
  "app/TimeSPanPlannerPage/CHECK_AVAILABILITY_SUCCESS";

export const PLAN_AVAILABILITY = "app/TimeSPanPlannerPage/PLAN_AVAILABILITY";
export const PLAN_AVAILABILITY_FAILED =
  "app/TimeSPanPlannerPage/PLAN_AVAILABILITY_FAILED";
export const PLAN_AVAILABILITY_SUCCESS =
  "app/TimeSPanPlannerPage/PLAN_AVAILABILITY_SUCCESS";
/**
 * Activity
 */
export const SAVE_ACTIVITY = "app/TimeSpanPlannerPage/SAVE_ACTIVITY";
export const REMOVE_ACTIVITY = "app/TimeSpanPlannerPage/REMOVE_ACTIVITY";

/**
 * Other
 */
export const RESET = "app/TimeSpanPlannerPage/RESET";

/**
 * Urls
 */
export function CHECK_AVAILABILITY_URL() {
  return `practices/${getPractice().id}/checkAvailability`;
}

export function CHECK_AVAILABILITY_RESULT_URL() {
  return `practices/${getPractice().id}/checkAvailabilityResult`;
}

export function PLAN_ACTIVITY_URL() {
  return `practices/${getPractice().id}/planActivity`;
}

export function PLAN_ACTIVITY_RESULT_URL() {
  return `practices/${getPractice().id}/planActivityResult`;
}
